import { Constantes, Environment, ParceiroSistema, IListaBandeiras } from './environment.interface';

const urlBaseAPI = 'https://apis.brasilcap.info/b2cap/v1/';

export const environment: Environment = {
  production: true,
  ambiente: 'dev',
  urlBaseAPI: urlBaseAPI,
  idCanalBNB: 2,
  idCanalCapfiador: 12,
  urlCEP: 'https://viacep.com.br/ws/{cep}/json/',
  codConvenio: 2774925473
};

export const constantes: Constantes = {
  TIPOS_CONTRATACAO: {
      VENDA: 2,
      TITULO: 1
  },
  ID_CANAL_SOLICITACAO: 10,
  PAGINATOR:{
    DEFAULT_PAGE_SIZE: 10,
    DEFAULT_PAGE_SIZE_OPTIONS:  [5, 10, 25, 100]
  }
}

export const parceiros: ParceiroSistema = {
  BNB: {
    id: 1, title: 'BNB'
  },
  BRASILCAP: {
    id: 2, title: 'BRASILCAP'
  },
  BB: {
    id: 3, title: 'BB'
  },
  PROMOTIVA: {
    id: 4, title: 'PROMOTIVA'
  },
  CANETAO: {
    id: 5, title: 'CANETAO'
  },
  BANRISUL: {
    id: 6, title: 'BANRISUL'
  },
  CAPFIADOR: {
    id: 17, title: 'CAPFIADOR'
  },
  IDEE: {
    id: 18, title: 'IDEE'
  },
  O2: {
    id: 19, title: 'O2'
  }
};

export const listaBandeiras: IListaBandeiras[] = [
  {
    id: "001",
    desc: 'Visa'
  },
  {
    id: "002",
    desc: 'Master'
  },
  {
    id: "007",
    desc: 'Elo'
  }
];
